import React from 'react';
import { Field } from 'formik';

// import styles from './cardFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const { profileQuestions } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const QAndAForm = () => {
  return (
    <div>
      {profileQuestions.map((profileQuestion, idx) => (
        <Field
          key={idx}
          component={InputField}
          name={`userProfile.profileAnswers[${idx}].answer`}
          type="textarea"
          label={profileQuestion.question}
        />
      ))}
    </div>
  );
};

export default QAndAForm;
